import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCashInoutIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.76001 16.8V15.73C11.24 15.49 11.93 14.56 11.93 13.47C11.93 12.38 11.18 11.7 9.63001 11.34V9.49C10.16 9.61 10.52 9.86 10.79 10.16L11.8 9.25C11.31 8.69 10.65 8.35 9.76001 8.25V7.2H8.49001V8.25C7.05001 8.42 6.29001 9.2 6.29001 10.37C6.29001 11.45 6.97001 12.19 8.64001 12.53V14.54C8.02001 14.45 7.49001 14.15 7.07001 13.7L6.07001 14.61C6.63001 15.22 7.37001 15.68 8.50001 15.78V16.8H9.77001H9.76001ZM9.63001 12.75C10.26 12.94 10.4 13.27 10.4 13.6C10.4 14.02 10.16 14.37 9.63001 14.51V12.75ZM7.83001 10.32C7.83001 9.89 8.07001 9.59 8.64001 9.47V11.12C8.07001 10.96 7.83001 10.74 7.83001 10.32Z"
        fill={color}
      />
      <path
        d="M13.03 18.03C11.84 18.83 10.44 19.25 9 19.25C5 19.25 1.75 16 1.75 12C1.75 8.00001 5 4.75001 9 4.75001C10.44 4.75001 11.83 5.17001 13.03 5.97001C13.83 6.52001 14.68 5.25001 13.86 4.72001C12.42 3.75001 10.74 3.24001 9 3.24001C4.18 3.25001 0.25 7.18001 0.25 12C0.25 16.82 4.18 20.75 9 20.75C10.74 20.75 12.42 20.24 13.86 19.27C14.68 18.74 13.83 17.47 13.03 18.02V18.03Z"
        fill={color}
      />
      <path
        d="M14.75 9.62H21.74L19.81 11.55C19.23 12.12 20.13 13.02 20.69 12.43L23.69 9.43C23.93 9.19 23.93 8.79 23.69 8.55L20.69 5.55C20.12 4.97 19.22 5.87 19.81 6.43L21.74 8.36H14.75C14.41 8.36 14.13 8.64 14.13 8.98C14.13 9.32 14.41 9.6 14.75 9.6V9.62Z"
        fill={color}
      />
      <path
        d="M23.25 14.38H16.26L18.19 12.45C18.77 11.88 17.87 10.98 17.31 11.57L14.31 14.57C14.07 14.81 14.07 15.21 14.31 15.45L17.31 18.45C17.88 19.03 18.78 18.13 18.19 17.57L16.26 15.64H23.25C23.59 15.64 23.87 15.36 23.87 15.02C23.87 14.68 23.59 14.4 23.25 14.4V14.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCashInoutIcon.displayName = 'PayCashInoutIcon';
